module.exports = __webpack_public_path__ + "img/Gyorfi-Pal-cikk.8eb5f729.jpg";